/**
 * Rôles de gestion attribuables à la corporate d'une plateforme : les
 * déclinaisons Gestionnaire, rôles legacy volontairement conservés (le Portail
 * Gestion n'est construit qu'en minimal, pour les valideurs) qui alimentent les
 * annuaires de la configuration des tunnels. Doit rester aligné avec la liste blanche serveur
 * (CorporateProvisioningManager.RolesSupplementairesAutorises) — `value` =
 * nom exact du rôle ABP. Grossiste / Propriétaire Produit : supprimés à la
 * refacto (remplacés par la sous-nature GRO et la brique Conception d'offre).
 */
export interface CorporateRoleOption {
  value: string;
  label: string;
  description: string;
}

export const CORPORATE_ROLE_OPTIONS: CorporateRoleOption[] = [
  {
    value: 'Gestionnaire Contrat',
    label: 'Gestionnaire Contrat',
    description: 'Gestion des contrats pour le compte des porteurs de risques.',
  },
  {
    value: 'Gestionnaire Sinistre',
    label: 'Gestionnaire Sinistre',
    description: 'Gestion des sinistres.',
  },
  {
    value: 'Gestionnaire Comptabilité',
    label: 'Gestionnaire Comptabilité',
    description: 'Gestion comptable (quittances, reversements).',
  },
  {
    // Brique (pas un rôle legacy) : successeur des anciens Grossiste /
    // Propriétaire Produit.
    value: "Conception d'offre",
    label: "Conception d'offre",
    description: 'Paramétrer produits, garanties et tunnels (propriétaire de produits, grossiste).',
  },
  {
    // Brique réservée aux compagnies : droit de regard du porteur de risque sur
    // les dossiers des tunnels dont sa PM porte une garantie.
    value: 'Consultation porteur de risque',
    label: 'Consultation porteur de risque',
    description: 'Consulter simulations, devis et contrats des tunnels portés (lecture seule).',
  },
  {
    // Brique, miroir de la liste blanche serveur
    // (CorporateProvisioningManager.BriquesSupplementairesAutorisees).
    value: 'Valideur',
    label: 'Valideur',
    description: 'Valider les devis des tunnels qui le nomment valideur (Portail Gestion).',
  },
];
